export const currentDate = new Date(2025, 6, 8); // July 8, 2025, as per the provided date

export const resumeItems = [
  {
    title: 'Quality Assurance Engineer',
    year: 'Jun 2023 - Present',
    place: 'Jabar Digital Service',
    description: [
      'Developed E2E Automation Tests using Cypress for SIDEBAR and Jabar Form.',
      'Built CI/CD pipelines with GitHub Actions for daily/weekly test execution.',
      'Automated API Testing for complex cases (e.g., OAuth, Spreadsheets v3) and conducted Performance Testing using K6.',
      'Executed Monkey, Sanity, Smoke, and Regression Testing.',
      'Reported defects via Qase.io and ClickUp.',
      'Performed Manual API Testing using Postman.',
      'Reported Automation Test Results using Cypress Cloud.',
      'Researched migration from Cypress to Playwright with Allure.'
    ]
  },
  {
    title: 'Quality Assurance Engineer',
    year: 'Jun 2022 - May 2023',
    place: 'PT. Halal Pedia Indonesia',
    description: [
      'Developed Test Plans, Test Scenarios, and Test Cases to ensure comprehensive test coverage.',
      'Executed manual testing & reported results using Qase.io, and synchronized with the Development Team and CTO for issue resolution.',
      'Conducted Sanity, Smoke, and Regression Testing for Halalpedia Web and Mobile App across releases.',
      'Performed API Testing using Postman to validate backend functionality and integration.',
      'Coordinated Quality Testing Activities, including estimation, prioritization, and planning, to meet deadlines.'
    ]
  }
];
